<template>
  <div>
    <h1 class="subtitle">Proveedores</h1>
    <hr />
    <div class="columns">
      <div class="column is-9">
        <button class="button is-success" @click="showBox = true">
          <b-icon icon="plus" size="is-small"></b-icon> <span>Agregar</span>
        </button>
      </div>
      <div class="column is-3">
        <input
          type="text"
          class="input is-pulled-right"
          @keyup="searchData"
          placeholder="Buscar"
          v-model="search"
        />
      </div>
    </div>
    <b-table
      :data="data"
      :loading="loading"
      paginated
      bordered
      backend-pagination
      :total="total"
      :per-page="perPage"
      aria-next-label="Siguiente"
      aria-previous-label="Anterior"
      aria-page-label="Pág."
      aria-current-label="Pág. actual"
      @page-change="onPageChange"
    >
      <template slot-scope="props">
        <b-table-column field="ruc" label="RUC" header-class="is-info">
          {{ props.row.ruc }}
        </b-table-column>
        <b-table-column field="razon_social" label="RAZON SOCIAL" header-class="is-info">
          {{ props.row.razon_social }}
        </b-table-column>
        <b-table-column field="direccion" label="DIRECCION" header-class="is-info">
          {{ props.row.direccion }}
        </b-table-column>
        <b-table-column field="email" label="EMAIL" header-class="is-info">
          {{ props.row.email }}
        </b-table-column>
        <b-table-column field="cuenta_detraccion" label="CTA. DETRACCION" header-class="is-info">
          {{ props.row.cuenta_detraccion }}
        </b-table-column>
        <b-table-column field="es_activo" label="ESTADO" centered header-class="is-info">
          <b-icon
            title="Activo"
            v-if="props.row.es_activo"
            icon="check-circle-outline"
            type="is-success"
          ></b-icon>
          <b-icon
            title="Inactivo"
            v-else
            icon="close-circle"
            type="is-danger"
          ></b-icon>
        </b-table-column>
        <b-table-column field="es_critico" label="CRITICIDAD" centered header-class="is-info">
          <b-icon
            title="Critico"
            v-if="props.row.es_critico"
            icon="check-circle-outline"
            type="is-success"
          ></b-icon>
          <b-icon
            title="No es Critico"
            v-else
            icon="close-circle"
            type="is-danger"
          ></b-icon>
        </b-table-column>
        <b-table-column field="es_nacional" label="NACIONAL" centered header-class="is-info">
          <b-icon
            title="Nacional"
            v-if="props.row.es_nacional"
            icon="flag"
            type="is-success"
          ></b-icon>
          <b-icon
            :title="getPais(props.row.id_pais)"
            v-else
            icon="earth"
            type="is-info"
          ></b-icon>
        </b-table-column>
        <b-table-column label="" header-class="is-info">
          <a
            href="#"
            @click.prevent="loadEditProveedor(props.row)"
            title="Modificar"
          >
            <b-icon icon="pencil" type="is-info"></b-icon>
          </a>
          <a
            href="#"
            @click.prevent="showCuentasBox(props.row)"
            title="Cuentas"
          >
            <b-icon icon="bank" type="is-success"></b-icon>
          </a>
          <a href="#" @click.prevent="deleteRow(props.row)" title="Eliminar">
            <b-icon icon="delete" type="is-danger"></b-icon>
          </a>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>No se encontraron Proveedores</p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :on-cancel="cleanAddProveedorForm"
      :active.sync="showBox"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-Box
    >
      <form>
        <ValidationObserver v-slot="{ passes }">
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Proveedor</p>
            </header>
            <section class="modal-card-body">
              <div class="columns">
                <div class="column">
                  <b-field>
                    <b-checkbox v-model="proveedor.es_nacional">
                      {{ proveedor.es_nacional ? "NACIONAL" : "INTERNACIONAL" }}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="PAIS">
                    <b-autocomplete
                      v-model="searchPais"
                      :open-on-focus="true"
                      :data="filteredPaises"
                      field="nombre"
                      @select="option => (proveedor.id_pais = option.id_pais)"
                      :disabled="proveedor.es_nacional"
                    >
                    </b-autocomplete>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="RUC"
                      :message="errors"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      ><b-input
                        :disabled="proveedor.id_proveedor"
                        v-model="proveedor.ruc"
                      ></b-input
                    ></b-field>
                  </ValidationProvider>
                </div>
                <div class="column">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="RAZON SOCIAL"
                      :message="errors"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      ><b-input v-model="proveedor.razon_social"></b-input
                    ></b-field>
                  </ValidationProvider>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <ValidationProvider
                    rules="required|email"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="EMAIL"
                      :message="errors"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      ><b-input v-model="proveedor.email"></b-input
                    ></b-field>
                  </ValidationProvider>
                </div>
                <div class="column">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="TELEFONO"
                      :message="errors"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      ><b-input v-model="proveedor.telefono"></b-input
                    ></b-field>
                  </ValidationProvider>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="DIRECCION"
                      :message="errors"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      ><b-input v-model="proveedor.direccion"></b-input
                    ></b-field>
                  </ValidationProvider>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <ValidationProvider
                      rules="required"
                      v-slot="{ errors, valid }"
                  >
                    <b-field
                        label="ESPECIALIDAD"
                        :message="errors"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    ><b-input v-model="proveedor.especialidad"></b-input
                    ></b-field>
                  </ValidationProvider>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field horizontal>
                    <b-checkbox v-model="proveedor.es_activo">
                      {{ proveedor.es_activo ? "ACTIVO" : "INACTIVO" }}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column">
                  <b-field horizontal>
                    <b-checkbox v-model="proveedor.es_critico">
                      {{ proveedor.es_critico ? "CRITICO" : "NO CRITICO" }}
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="CUENTA DETRACCION"
                    ><b-input v-model="proveedor.cuenta_detraccion"></b-input
                  ></b-field>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button
                class="button"
                type="button"
                @click="
                  showBox = false;
                  cleanAddProveedorForm();
                "
              >
                Cerrar
              </button>
              <button
                class="button is-primary"
                @click.prevent="passes(addProveedor)"
              >
                Guardar
              </button>
            </footer>
          </div>
        </ValidationObserver>
      </form>
    </b-modal>
    <b-modal
      :active.sync="showBoxCuentas"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-Box
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ proveedor_cuenta }}</p>
        </header>
        <section class="modal-card-body">
          <button
            class="button is-success"
            @click.prevent="
              showBoxCuentas = false;
              showBoxAgregarCuenta = true;
            "
          >
            Agregar Cuenta
          </button>
          <b-table :data="cuentas_proveedor">
            <template slot-scope="props">
              <b-table-column field="banco" label="BANCO">
                {{ props.row.banco }}
              </b-table-column>
              <b-table-column field="moneda" label="MONEDA">
                {{ props.row.moneda }}
              </b-table-column>
              <b-table-column field="tipo_cuenta" label="TIPO DE CUENTA">
                {{ props.row.tipo_cuenta }}
              </b-table-column>
              <b-table-column field="cuenta" label="CUENTA">
                {{ props.row.cuenta }}
              </b-table-column>
              <b-table-column field="email" label="CCI">
                {{ props.row.cci }}
              </b-table-column>
              <b-table-column label="">
                <a href="#" @click.prevent="deleteCuenta(props.row)">
                  <b-icon
                    title="Eliminar"
                    icon="delete"
                    type="is-danger"
                  ></b-icon>
                </a>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>No se encontraron Cuentas asociadas a este Proveedor</p>
                </div>
              </section>
            </template>
          </b-table>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="showBoxCuentas = false"
          >
            Cerrar
          </button>
        </footer>
      </div>
    </b-modal>
    <b-modal
      :active.sync="showBoxAgregarCuenta"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-Box
      >>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ proveedor_cuenta }} - Agregar Cuenta
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Banco">
            <b-select
              v-model="cuenta_proveedor.id_banco"
              placeholder="Banco"
              required
            >
              <option
                v-for="banco in bancos"
                :key="banco.id_banco"
                :value="banco.id_banco"
                >{{ banco.descripcion }}</option
              >
            </b-select>
          </b-field>
          <b-field label="Moneda">
            <b-select
              v-model="cuenta_proveedor.id_moneda"
              placeholder="Moneda"
              required
            >
              <option v-for="c in coins" :key="c.id" :value="c.id">{{
                c.descripcion
              }}</option>
            </b-select>
          </b-field>
          <b-field label="Tipo de Cuenta">
            <b-select
              v-model="cuenta_proveedor.tipo_cuenta"
              placeholder="Tipo de Cuenta"
              required
            >
              <option
                v-for="tipo in tipo_cuentas"
                :key="tipo.id"
                :value="tipo.id"
                >{{ tipo.descripcion }}</option
              >
            </b-select>
          </b-field>
          <b-field label="Número de Cuenta">
            <b-input
              v-model="cuenta_proveedor.cuenta"
              placeholder="Número de Cuenta"
              required
            >
            </b-input>
          </b-field>
          <b-field label="CCI">
            <b-input v-model="cuenta_proveedor.cci" placeholder="CCI" required>
            </b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="
              showBoxAgregarCuenta = false;
              showBoxCuentas = true;
              cleanAddProveedorForm();
            "
          >
            Cerrar
          </button>
          <button class="button is-success" type="button" @click="addCuenta">
            Agregar
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { coins, accountType } from "../constants/constants";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "ProveedorList",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      data: [],
      perPage: 10,
      total: 0,
      page: 1,
      search: "",
      timer: null,
      showBox: false,
      searchPais: "",
      proveedor: {
        id_proveedor: null,
        ruc: "",
        razon_social: "",
        direccion: "",
        email: "",
        cuenta_detraccion: "",
        es_activo: true,
        es_critico: false,
        es_nacional: true,
        id_pais: null,
        telefono: "",
        especialidad: ''
      },
      paises: [],
      showBoxCuentas: false,
      showBoxAgregarCuenta: false,
      cuentas_proveedor: [],
      proveedor_cuenta: "",
      proveedor_id_cuenta: null,
      cuenta_proveedor: {
        id_banco: null,
        id_moneda: null,
        tipo_cuenta: null,
        cuenta: "",
        cci: ""
      },
      bancos: [],
      coins: coins,
      tipo_cuentas: accountType
    };
  },
  methods: {
    deleteRow(row) {
      this.$buefy.dialog.confirm({
        message: "Esta seguro de eliminar al proveedor",
        onConfirm: () => {
          axios
            .delete("/proveedor/delete", {
              data: { id_proveedor: row.id_proveedor }
            })
            .then(
              () => {
                this.$buefy.toast.open({
                  message: `Se elimino el proveedor ${row.razon_social}`,
                  type: "is-success"
                });
                this.loadDataTable();
              },
              () => {
                this.$buefy.toast.open({
                  message: `Ocurrio un problema al eliminar al proveedor`,
                  type: "is-danger"
                });
              }
            );
        }
      });
    },
    loadDataTable() {
      let _self = this;
      _self.loading = true;
      axios
        .post("/proveedor/list", {
          search: this.search,
          length: this.perPage,
          start: (this.page - 1) * this.perPage
        })
        .then(
          response => {
            _self.data = response.data.data;
            _self.total = response.data.total;
            _self.loading = false;
          },
          () => {
            _self.loading = false;
          }
        );
    },
    onPageChange(page) {
      this.page = page;
      this.loadDataTable();
    },
    searchData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let _self = this;
      this.timer = setTimeout(() => _self.loadDataTable(), 1000);
    },
    addProveedor() {
      let _self = this;
      axios.post("/proveedor/save", _self.proveedor).then(
        response => {
          this.$buefy.toast.open({
            message: `Se ${
              _self.proveedor.id_proveedor ? "actualizo" : "agrego"
            } el proveedor ${response.data.razon_social}`,
            type: "is-success"
          });
          this.showBox = false;
          this.cleanAddProveedorForm();
          this.loadDataTable();
        },
        err => {
          this.showBox = false;
          this.cleanAddProveedorForm();
          this.$buefy.toast.open({
            message: err.response.data.message,
            type: "is-danger"
          });
        }
      );
    },
    loadPaises() {
      let _self = this;
      axios.get("/pais/list").then(
        res => (_self.paises = res.data),
        err => console.error(err)
      );
    },
    getPais(id_pais) {
      if (id_pais) {
        let pais = this.paises.filter(pais => pais.id_pais === id_pais);
        return pais ? pais[0].nombre : "";
      }
      return "";
    },
    cleanAddProveedorForm() {
      this.proveedor = {
        id_proveedor: null,
        ruc: "",
        razon_social: "",
        direccion: "",
        email: "",
        cuenta_detraccion: "",
        es_activo: true,
        es_critico: false,
        es_nacional: true,
        id_pais: null
      };
      this.searchPais = "";
    },
    loadEditProveedor(row) {
      this.proveedor = row;
      this.searchPais = this.getPais(row.id_pais);
      this.showBox = true;
    },
    showCuentasBox(row) {
      this.proveedor_cuenta = row.razon_social;
      this.proveedor_id_cuenta = row.id_proveedor;
      this.loadCuentas(row.id_proveedor);
    },
    loadCuentas(id_prov) {
      axios.post("/cuenta-proveedor/list", { id_proveedor: id_prov }).then(
        resp => {
          this.cuentas_proveedor = resp.data;
          this.showBoxCuentas = true;
        },
        err => {
          console.error(err);
        }
      );
    },
    cleanAddCuentaProveedorForm() {
      this.cuenta_proveedor = {
        id_banco: null,
        id_moneda: null,
        tipo_cuenta: null,
        cuenta: "",
        cci: ""
      };
    },
    addCuenta() {
      this.cuenta_proveedor.id_proveedor = this.proveedor_id_cuenta;
      let _self = this;
      axios.post("/cuenta-proveedor/add", this.cuenta_proveedor).then(() => {
        _self.loadCuentas(_self.proveedor_id_cuenta);
        _self.showBoxAgregarCuenta = false;
        _self.cleanAddCuentaProveedorForm();
        this.$buefy.toast.open({
          message: `Se agrego la cuenta`,
          type: "is-success"
        });
      });
    },
    deleteCuenta(row) {
      let _self = this;
      this.$buefy.dialog.confirm({
        message: "Esta seguro de eliminar la cuenta",
        onConfirm: () => {
          axios
            .delete("/cuenta-proveedor/delete", {
              data: { id_cuenta_proveedor: row.id_cuenta_proveedor }
            })
            .then(
              () => {
                _self.cuentas_proveedor = _self.cuentas_proveedor.filter(
                  e => e.id_cuenta_proveedor !== row.id_cuenta_proveedor
                );
                this.$buefy.toast.open({
                  message: `Se elimino la cuenta`,
                  type: "is-success"
                });
                this.loadDataTable();
              },
              () => {
                this.$buefy.toast.open({
                  message: `Ocurrio un problema al eliminar la cuenta`,
                  type: "is-danger"
                });
              }
            );
        }
      });
    },
    loadBancos() {
      let _self = this;
      axios.get("/banco/list").then(
        res => (_self.bancos = res.data),
        err => console.error(err)
      );
    }
  },
  computed: {
    filteredPaises() {
      return this.paises.filter(pais => {
        return (
          pais.nombre
            .toString()
            .toLowerCase()
            .indexOf(this.searchPais.toLowerCase()) >= 0
        );
      });
    }
  },
  mounted() {
    this.loadBancos();
    this.loadPaises();
    this.loadDataTable();
  }
};
</script>

<style scoped></style>
